import React from "react";
import "./Footer.css";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import {
  faEnvelope,
  faGlobe,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
const Footer = () => {
  const QuickLinks = [
    { label: "Home", link: "" },
    { label: "Contact Us", link: "/contact-support" },
    { label: "Faq", link: "/faq" },
    { label: "Why Profcyma", link: "/why-profcyma" },
    { label: "Apply Now", link: "/apply-now" },
    { label: "See Your Emi", link: "/see-your-emi" },
    { label: "Terms & Condition", link: "/terms-conditions" },
    { label: "Privacy Policy", link: "/privacy-policy" },
  ];

  const Loans = [
    { lable: "Personal Loan" },
    { lable: "Home Loan" },
    { lable: "Business Loan" },
    // { lable: "Car Loan" },
    // { lable: "Credit Card Loan" },
    // { lable: "Gold Loan" },
    // { lable: "Micro Loan" },
    // { lable: "Property Loan" }
  ];
  const Insurances = [
    "Term Life Insurance",
    "Health Insurance",
    "Car Insurance",
    "Bike Insurance",
    "Term Insurance",
    "Travel Insurance",
    "Child Insurance Plan",
    "Commercial Insurance",
    "Asset Insurance",
    "Retirement Plans",
    "Home Insurance",
    "Investment Plans",
  ];

  // const Calculators = ["Personal Loan EMI", "EMI Calculator", "Eligibility Calculator"]

  const Calculators = [
    { label: "Personal Loan EMI", link: "", id: "calculate_loan" },
    { label: "EMI Calculator", id: "calculate_loan" },
    { label: "Eligibility Calculator", id: "calculate_loan" },
  ];

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      const offset = 100;
      const elementPosition =
        section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
    }
  };

  const icons = [
    {
      icon: faLinkedinIn,
      link:
        "https://www.linkedin.com/company/106362743/admin/page-posts/published/",
    },
    { icon: faTwitter, link: "https://x.com/profcymafinace" },
    {
      icon: faFacebookF,
      link: "https://www.facebook.com/profile.php?id=61572947796486",
    },
    {
      icon: faInstagram,
      link: "https://www.instagram.com/profcyma_finance/?next=%2F&hl=en",
    },
  ];

  const payment_method = [
    "/assets/Image/Footer/img1.png",
    "/assets/Image/Footer/img2.png",
    "/assets/Image/Footer/img3.png",
    "/assets/Image/Footer/img4.png",
  ];

  const contactData = [
    {
      link: "/",
      label:
        "2nd floor, Office No 3, Opp. High-Class Soc., M.No. 734, Near Suryadutta College, Bavdhan Khurd, Pune 411021.",
      icon: faLocationDot,
    },
    {
      link: "/",
      label: "info@profcymafinance.com",
      icon: faEnvelope,
    },
    {
      link: "https://www.profcymafinance.com/",
      target: "_blank",
      label: "www.profcymafinance.com",
      icon: faGlobe,
    },
    {
      link: "/",
      label: "1800-267-8961 / +91 96077 55557",
      icon: faPhone,
    },
  ];

  const navigate = useNavigate();

  return (
    <>
      <section className="footer_section">
        <div className="main_footer_div">
          <div className="row me-0 ms-0">
            <div className="col-lg-8 col-md-12 col-12 order-lg-1 order-md-2 order-sm-2 order-2 ps-0">
              <div className="left_side_main_div">
                <div className="footer_nav_div order-md-1 order-sm-2 order-2">
                  <div className="row">
                    <div className="col-xxl-4 col-xl-3 col-sm-2 col-md-2 col-3 order-sm-1 ">
                      <div className="logo_holder">
                        <img
                          className="headlogo"
                          src="/assets/Image/Header/header_logo.png"
                          alt="Logo"
                        />
                      </div>
                    </div>

                    <div className="col-xxl-8 col-xl-9 col-lg-12 col-md-10 col-sm-12 col-12 order-sm-2">
                      <div className="row">
                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 ">
                          <h2 className="navs_heading">Quick Links</h2>

                          <div className="sub_navs_div ">
                            {QuickLinks?.map((item, index) => {
                              return (
                                <div className="">
                                  <Link
                                    key={index}
                                    to={item?.link}
                                    className="link"
                                    onClick={item?.onClick}
                                  >
                                    <p>{item?.label}</p>
                                  </Link>
                                </div>
                              );
                            })}
                            <br></br>
                          </div>
                        </div>

                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6">
                          <h2 className="navs_heading">Loans</h2>

                          <div className="sub_navs_div">
                            {Loans?.map((item, index) => {
                              return (
                                <Link
                                  className="link"
                                  key={index}
                                  onClick={() => scrollToSection("our_service")}
                                >
                                  {item?.lable}
                                </Link>
                              );
                            })}
                          </div>
                        </div>

                        {/* <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6">
                          <h2 className="navs_heading">Insurances</h2>

                          <div className="sub_navs_div">
                            {Insurances?.map((item) => {
                              return (
                                <Link onClick={() => scrollToSection("Insurance")} className="link">
                                  {item}
                                </Link>
                              )
                            })}
                          </div>

                        </div> */}

                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6">
                          <h2 className="navs_heading">Calculators</h2>

                          <div className="sub_navs_div">
                            {Calculators?.map((item) => {
                              return item.id ? (
                                <p
                                  className="link"
                                  onClick={() => scrollToSection(item.id)}
                                  style={{ cursor: "pointer" }}
                                >
                                  {item?.label}
                                </p>
                              ) : (
                                <Link to={item?.link} className="link">
                                  {item?.label}
                                </Link>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 order-3">
                      <div className="note_holder">
                        <span>
                          {" "}
                          * Profcyma Financial Solutions Pvt. Ltd. is a
                          financial facilitation and advisory service provider.
                          We do not provide loans or issue credit directly.{" "}
                          <b>
                            Loan approval, interest rates, and terms are
                            determined solely by third-party banks and NBFCs.
                          </b>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="footer_social_div order-md-2 order-sm-1 order-1">
                  {icons?.map((item) => {
                    return (
                      <Link
                        className="icon_holder"
                        to={item?.link}
                        target="_blank"
                      >
                        <FontAwesomeIcon icon={item?.icon} className="icon" />
                      </Link>
                    );
                  })}
                </div>

                <div className="payment_method_div">
                  <h3 className="title">Payment Methods</h3>

                  <div className="card_holder">
                    {payment_method?.map((item) => {
                      return (
                        <div className="payment_card">
                          <img
                            className="headlogo"
                            src={process.env.PUBLIC_URL + item}
                            alt="Logo"
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1">
              <div className="rigth_side_div">
                {contactData?.map((item) => {
                  return (
                    <div className="content_holder">
                      <div className="icon_holder">
                        <FontAwesomeIcon icon={item?.icon} className="icon" />
                      </div>
                      <Link to={item?.link} target={item?.target}>
                        <div className="text_holder">
                          <p className="text">{item?.label}</p>
                        </div>
                      </Link>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <div className="copy_right_div">
          <p className="text">
            © Copyright 2025 profcymafinance.com. All Rights Reserved. Developed
            by{" "}
            <a
              class="bottom_footer_text"
              href="https://profcymaglobal.com"
              target="_blank"
            >
              Profcyma
            </a>
          </p>
        </div>
      </section>
    </>
  );
};

export default Footer;
